import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	Row,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFieldList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditFieldModal from './Add_Edit/AddEditFieldModal';
import DeleteFieldModal from './Delete/DeleteField';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const FieldsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorFields = createSelector(
		state => state.Field,
		field => ({
			fieldList: field.fieldList,
			isLoadingList: field.isLoadingList,
			isFieldSuccess: field.isFieldSuccess,
			error: field.error,
			isAdding: field.isAdding,
			isAdded: field.isAdded,
			isAddError: field.isAddError,
			isUpdating: field.isUpdating,
			isUpdated: field.isUpdated,
			isUpdateError: field.isUpdateError,
			isDeleting: field.isDeleting,
			isDeleted: field.isDeleted,
			isDeleteError: field.isDeleteError,
		})
	);

	const { fieldList, isLoadingList } = useSelector(selectorFields);

	useEffect(() => {
		dispatch(getFieldList());
	}, []);

	const [dataField, setDataField] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	const [modal, setModal] = useState(false);
	const [modalArticle, setModalArticle] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = field => {
		setDataField(field);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = field => {
		setDataField(field);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'field',
				columnDefType: 'display',
				
				width: 10,
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const fieldData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(fieldData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const fieldData = cellProps.row.original;
													handleClickDelete(fieldData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				
			},
			{
				header: 'Descripción',
				accessorKey: 'description',
				
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataField({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Campo
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={fieldList || []}
								isLoadingData={isLoadingList}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataField({});
											handleToggleModal();
										},
										title: 'Crear Campo',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFieldModal
				dataField={dataField}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				// activeTab={activeTab}
				// toggleTab={toggleTab}
			/>

			<DeleteFieldModal
				dataField={dataField}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default FieldsList;
